/// <reference path="./../Tag.ts" />
/// <reference path="./Input.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class Radio extends Input {
        public getText(): string {
            return this.getElement().value;
        }

        public clear(): this {
            this.getElement().value = "";
            return this;
        }

        public setText(value: any): void {
            this.getElement().value = value;
        }

        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.setAttribute("type", "radio");
        }
    }
}
